export interface INotifyCancellationEmails {
  id?: number;
  emailAddress?: string;
}

export const defaultValue: Readonly<INotifyCancellationEmails> = {};
